import {defineMessages} from "react-intl";

/**
 * Error types that are used when validating the form
 * The values are used to find the translation
 */
// TODO: clean this enum up, use type instead
export enum LimitErrorType {
    AGENT = "agent",
    SUPERVISOR = "supervisor",
    ALLOCATION_EXCEEDED = "allocation_exceeded",
    SYSTEM_LIMIT_EXCEEDED = "system_limit_exceeded",
    DEVICE_LESS = "device_less",
    DEVICE_MORE = "device_more",
    DEVICES_NEEDED = "devices_needed",
}

// Static, exhaustive messages for LimitErrorType to avoid dynamic IDs
export const LIMIT_ERROR_MESSAGES = defineMessages<LimitErrorType>({
    agent: {
        id: "extensionQuotaSettings.errors.agent",
        defaultMessage: "Agent can not be removed while being in call queue: {groups}",
    },
    supervisor: {
        id: "extensionQuotaSettings.errors.supervisor",
        defaultMessage: "Supervisor can not be removed while being a supervisor of call queue: {groups}",
    },
    allocation_exceeded: {
        id: "extensionQuotaSettings.errors.allocation_exceeded",
        defaultMessage: "Can not exceed allocated value for domain: {name}",
    },
    system_limit_exceeded: {
        id: "extensionQuotaSettings.errors.system_limit_exceeded",
        defaultMessage: "Can not exceed system limit",
    },
    device_less: {
        id: "extensionQuotaSettings.errors.device_less",
        defaultMessage: "New value of {name} devices is less than currently used value",
    },
    device_more: {
        id: "extensionQuotaSettings.errors.device_more",
        defaultMessage: "New value of {name} devices is greater than allocated value",
    },
    devices_needed: {
        id: "extensionQuotaSettings.errors.devices_needed",
        defaultMessage: "Quotas for device type(s) are less than currently used value:",
    },
});

/**
 * Limit object to be used in the form for easier validation.
 */
export interface Limit {
    /** Value of the limit item that comes from the user package. */
    up: number;

    /** Value of the limit item set in the form. */
    form: number;

    /** Name of the limit item. */
    name: string;

    user: {
        /** Total number of quota item used by the extension. */
        used: number;

        /** Allocated value for the extension. */
        allocated: number;
    };
    domain: {
        /** Total number of quota item used inside the domain. */
        used: number;

        /** Allocated value for the domain. */
        allocated: number;
    };
    system: {
        /** Total allocations throughout all domains. */
        allocated: number;

        /** System limit (from limit config). Unlimited if null. */
        limit: number | null;
    };
}

// Error context for devices and capabilities
/**
 * Error context for devices and capabilities
 *
 * `name` | The name of the device or capability
 *
 * `type` | The type of the error
 *
 * `groups?` | The groups the extension is a member of
 */
export interface LimitError {
    name: string;
    type: LimitErrorType;
    groups?: string[];
}
